import { useTranslation } from "react-i18next";

// Pantalla de carga de la vista de manejo. Sin ella se veía un recuadro gris
// "seco" mientras bajaban MapLibre (~800 KB) y las primeras teselas (Daniel,
// 29-oct). Va fuera de DriveView para que el fallback del lazy no la descargue.
export default function DriveLoading() {
  const { t } = useTranslation("lite");
  return (
    <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-3 bg-gradient-to-b from-[#3a72b0] via-neutral-800 to-neutral-900 text-center">
      {/* Carretera en perspectiva con rayas que avanzan: dice "manejo" sin texto. */}
      <div className="relative h-24 w-28 overflow-hidden [perspective:120px]">
        <div className="absolute inset-x-6 -bottom-2 top-0 origin-bottom bg-neutral-700 [transform:rotateX(55deg)]">
          <div className="absolute inset-y-0 left-1/2 w-1 -translate-x-1/2 bg-[repeating-linear-gradient(to_bottom,rgba(255,255,255,.85)_0_10px,transparent_10px_22px)] motion-safe:animate-[driveLines_600ms_linear_infinite]" />
        </div>
      </div>
      <div className="flex items-center gap-2 px-3 text-[13px] font-medium text-white">
        <span className="h-4 w-4 rounded-full border-2 border-primary-500/30 border-t-primary-500 motion-safe:animate-spin" aria-hidden />
        {t("driveView.loading", "Preparando la vista de manejo")}
      </div>
      <p className="px-6 text-[11px] text-white/55">{t("driveView.loadingHint", "Cargando calles y edificios…")}</p>
      <style>{"@keyframes driveLines{from{background-position:0 0}to{background-position:0 22px}}"}</style>
    </div>
  );
}
